
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2899',
  depVersions: {
  "customer-portal-app": "static-1.2899",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9844",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25941",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5778",
  "hs-test-utils": "static-1.8208",
  "hub-http": "static-1.6404",
  "hub-http-shared-msw-handlers": "static-1.10417",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18781",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11661",
  "I18n": "static-7.1646",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6641",
  "payment-link-components": "static-1.23953",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7278",
  "quartz-core": "static-1.6497",
  "quartz-i18n": "static-1.953",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10394",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5471",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20150",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18234",
  "ui-components-test-utils": "static-1.5798",
  "UIComponents": "static-3.8607",
  "foundations-assets": "static-1.5060",
  "foundations-components": "static-1.8289",
  "foundations-theming": "static-1.4623",
  "foundations-theming-specialty": "static-1.2339",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1252",
  "quartz-config": "static-1.1056",
  "quartz-routing": "static-1.708",
  "quick-fetch": "static-1.4048",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16888",
  "rpc-client-utils": "static-1.4843",
  "sanitize-text": "static-1.8331",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4942",
  "ui-addon-react-router-dom": "static-1.9719",
  "usage-tracker": "static-1.7536",
  "usage-tracker-anonymous": "static-1.5953",
  "usage-tracker-core": "static-1.7386",
  "video-components-external": "static-1.11897",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3531",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3555",
  "quartz-webpack": "static-1.3502",
  "bend-plugin-quartz-routing": "static-1.356",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7866",
  "frontend-preferences-client": "static-1.8112",
  "laboratory-lib": "static-3.7337",
  "onboarding-scopes": "static-1.6644",
  "seat-types-lib": "static-1.433",
  "ui-addon-opt": "static-4.8546",
  "HeadJS": "static-2.778",
  "hs-test-utils-bend-plugin": "static-1.3319",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.211",
  "ts-schema": "static-1.4210",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8035",
  "content-media-capture": "static-1.5123",
  "cssUtils": "static-1.844",
  "customer-data-ui-utilities": "static-1.10011",
  "file-manager-components": "static-1.24173",
  "HubStyle": "static-2.11968",
  "knowledge-content-types": "static-1.8584",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10070",
  "ui-addon-i18n": "static-1.11333",
  "ui-business-units-lib": "static-1.9265",
  "ui-shepherd-react": "static-3.10447",
  "video-data-lib": "static-1.35555",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4508",
  "commerce-tours-lib": "static-1.6446",
  "customer-data-properties": "static-1.52223",
  "getting-started-shared-tasks": "static-1.18972",
  "growth-onboarding-reliability": "static-1.5267",
  "onboarding-tours": "static-1.16948",
  "reference-resolvers-lite": "static-1.8283",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9260",
  "user-context": "static-1.5297",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.853",
  "hubspotter-http": "static-1.4781",
  "icons": "static-2.666",
  "mobile-manifest-mixins": "static-1.552",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.953",
  "quartz-head": "static-1.943",
  "quartz-test": "static-1.953",
  "quartz-tracking": "static-1.657",
  "trellis-components": "static-1.2320",
  "ui-fonts": "static-1.923",
  "usage-tracker-container": "static-1.7526",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9612",
  "data-token-picker": "static-1.16730",
  "FileManagerLib": "static-1.39813",
  "property-translator": "static-1.5579",
  "atom": "static-1.5261",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6188",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5772",
  "react-create-root-preference": "static-1.46",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1207",
  "bend-plugin-foundations-components": "static-1.4558",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2301",
  "bend-plugin-foundations-theming": "static-1.3106",
  "foundations-theming-base": "static-1.3608",
  "stylex": "static-1.37",
  "interframe": "static-3.4941",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5950",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.253",
  "chirp-fetch": "static-1.2073",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4662",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4838",
  "content-media-composition-data-lib": "static-1.12927",
  "content-media-compositions": "static-2.16934",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4333",
  "magpie-lib": "static-1.5679",
  "magpie-types": "static-1.5139",
  "media-bridge-lib": "static-1.19247",
  "bender-build-tools": "static-1.3316",
  "inbound-db-properties-service-client": "static-1.3976",
  "superstore": "static-1.4944",
  "feedback-loader": "static-1.29639",
  "ai-components-ui-library": "static-1.9438",
  "ui-addon-video-player": "static-1.8892",
  "ui-coaching-tips": "static-1.29092",
  "ContentUtils": "static-1.68920",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4610",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4799",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1395",
  "copilot-toolkit": "static-1.11621",
  "avatar-components": "static-1.2684",
  "navigation-messaging": "static-1.7865",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8361",
  "commerce-products-lib": "static-1.10262",
  "crm-message-bus": "static-1.43526",
  "growth-data-modal": "static-1.5730",
  "hubspot-apollo-client": "static-1.5063",
  "onboarding-tours-client": "static-1.5162",
  "calling-global-api": "static-1.65153",
  "calling-internal-common": "static-1.31497",
  "calling-lifecycle-internal": "static-1.66535",
  "calling-lifecycle-messages": "static-1.58829",
  "conditional-properties-service-client": "static-1.3927",
  "crm-links": "static-1.6501",
  "crm-pipelines-api-client-types": "static-1.4268",
  "customer-data-objects-ui-components": "static-1.13217",
  "customer-data-properties-shared-msw-handlers": "static-1.9744",
  "customer-data-property-utils": "static-1.8282",
  "external-options-client-types": "static-1.4256",
  "formula-editor": "static-1.14585",
  "framework-data-schema-resolvers": "static-1.7080",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.364",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4346",
  "meetings-icalendar-utils-lib": "static-1.817",
  "multi-currency-client-types": "static-1.3822",
  "object-builder-ui-client": "static-1.49367",
  "pipeline-validation-client-types": "static-1.4097",
  "property-value-citations": "static-1.2837",
  "pulse": "static-1.800",
  "smart-property-lib": "static-1.8070",
  "tiered-pricing": "static-1.1745",
  "topics-actions-lib": "static-1.337",
  "ui-addon-form-validation": "static-1.11175",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3247",
  "growth-onboarding-next-action-utils": "static-1.2473",
  "navigation-components": "static-1.18538",
  "onboarding-tours-utils": "static-1.1014",
  "ui-shepherd-tracker": "static-1.7828",
  "ui-universal-auth": "static-1.9198",
  "batch-promise": "static-1.1730",
  "getting-started-shared-tasks-store": "static-1.18090",
  "hubspotter-http-shared-msw-handlers": "static-1.10415",
  "usage-tracker-session-replay": "static-1.5222",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1133",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6190",
  "FileManagerCore": "static-1.39672",
  "FileManagerImages": "static-1.37324",
  "video-components": "static-1.13899",
  "foundations-components-legacy": "static-1.1314",
  "purchase-motions-api": "static-1.6191",
  "signup-constants": "static-1.19344",
  "signup-ui-url-generator": "static-2.8244",
  "usage-tracker-public": "static-1.7347",
  "reactive-lib": "static-1.908",
  "simple-logging-lib": "static-1.3235",
  "chatspot-core": "static-1.22268",
  "growth-onboarding-feedback-components": "static-1.6766",
  "cms-field-types": "static-1.5001",
  "content-icons-ui": "static-1.2280",
  "integrations-lib": "static-1.16757",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.673",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.961",
  "customer-data-tracking": "static-1.7070",
  "products-iframe-lib": "static-1.8380",
  "products-ui-components-shared-msw-handlers": "static-1.10799",
  "restore-request-side-panel-lib": "static-1.1381",
  "onboarding-data-sync-lib": "static-1.2282",
  "hubspot-apollo-cache": "static-1.522",
  "calling-error-reporting": "static-1.31504",
  "shared-worker-versioning": "static-1.11223",
  "calling-usage-tracker": "static-1.6726",
  "voice-sms-access-library": "static-1.1673",
  "conversations-skeleton-state": "static-1.7433",
  "location-customization-utils-lib": "static-1.9826",
  "bark-lib": "static-1.16677",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6073",
  "react-codemirror": "static-1.10821",
  "fdsr-migration-layer": "static-1.199",
  "framework-builder-read-service-client": "static-1.4136",
  "framework-data-schema-quick-fetch": "static-1.6985",
  "persist-promise": "static-1.3887",
  "event-emitter": "static-1.1135",
  "bend-plugin-pulse": "static-1.303",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.487",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10500",
  "fsm": "static-1.3916",
  "policy-lib": "static-1.6971",
  "react-tinymce": "static-1.55749",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10563",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54875",
  "tinymce-plugins": "static-1.57989",
  "tinymce-themes": "static-1.56845",
  "growth-onboarding-next-action-components": "static-1.2501",
  "user-context-client": "static-1.4737",
  "nest": "static-1.421",
  "unified-auth-core-lib": "static-1.994",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4717",
  "video-embed": "static-1.36389",
  "social-insights-client-types": "static-1.22580",
  "flux-actions": "static-1.353",
  "integrations-error-boundary-lib": "static-1.14172",
  "integrations-tracking-lib": "static-1.5793",
  "native-integrations-shared-strings": "static-1.7964",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10550",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.712",
  "sales-views-client-types": "static-1.4443",
  "InboxConnectUtils": "static-4.15332",
  "meetings-connect-utils-lib": "static-1.7792",
  "calling-orchestration-schema": "static-1.36450",
  "crm-record-cards-service-types": "static-1.3715",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16126",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4692",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3227",
  "tinymce-data": "static-1.40960",
  "ui-addon-sales-email": "static-1.5398",
  "layout-dnd-components": "static-1.12799",
  "layout-dnd-utils": "static-1.11774",
  "ui-brand-identity-lib": "static-1.15986",
  "NamespacedHubStyle": "static-2.9181",
  "outpost": "static-1.4351",
  "universal-page-editor-lib": "static-1.3197",
  "adobe-sign-auth-lib": "static-1.235",
  "ads-unified-auth-lib": "static-1.733",
  "google-sheets-integration-lib": "static-1.802",
  "microsoft-drive-integration-lib": "static-1.907",
  "surveymonkey-integration-lib": "static-1.249",
  "slack-ui-library": "static-1.10583",
  "ContentData": "static-1.68995",
  "layout-data-lib": "static-1.10099",
  "advanced-menus-core": "static-1.15431",
  "advanced-menus-lib": "static-1.12325",
  "ExportDialog": "static-6.10565",
  "ui-memberships-settings-lib": "static-1.34573",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15430",
  "simple-menus-lib": "static-1.16947"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2899",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9844",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25941",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5778",
  "hs-test-utils": "/hs-test-utils/static-1.8208",
  "hub-http": "/hub-http/static-1.6404",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10417",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18781",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11661",
  "I18n": "/I18n/static-7.1646",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6641",
  "payment-link-components": "/payment-link-components/static-1.23953",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7278",
  "quartz-core": "/quartz-core/static-1.6497",
  "quartz-i18n": "/quartz-i18n/static-1.953",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10394",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5471",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20150",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18234",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5798",
  "UIComponents": "/UIComponents/static-3.8607",
  "foundations-assets": "/foundations-assets/static-1.5060",
  "foundations-components": "/foundations-components/static-1.8289",
  "foundations-theming": "/foundations-theming/static-1.4623",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2339",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1252",
  "quartz-config": "/quartz-config/static-1.1056",
  "quartz-routing": "/quartz-routing/static-1.708",
  "quick-fetch": "/quick-fetch/static-1.4048",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16888",
  "rpc-client-utils": "/rpc-client-utils/static-1.4843",
  "sanitize-text": "/sanitize-text/static-1.8331",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4942",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9719",
  "usage-tracker": "/usage-tracker/static-1.7536",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5953",
  "usage-tracker-core": "/usage-tracker-core/static-1.7386",
  "video-components-external": "/video-components-external/static-1.11897",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3531",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3555",
  "quartz-webpack": "/quartz-webpack/static-1.3502",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.356",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7866",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8112",
  "laboratory-lib": "/laboratory-lib/static-3.7337",
  "onboarding-scopes": "/onboarding-scopes/static-1.6644",
  "seat-types-lib": "/seat-types-lib/static-1.433",
  "ui-addon-opt": "/ui-addon-opt/static-4.8546",
  "HeadJS": "/HeadJS/static-2.778",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3319",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.211",
  "ts-schema": "/ts-schema/static-1.4210",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8035",
  "content-media-capture": "/content-media-capture/static-1.5123",
  "cssUtils": "/cssUtils/static-1.844",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10011",
  "file-manager-components": "/file-manager-components/static-1.24173",
  "HubStyle": "/HubStyle/static-2.11968",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10070",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11333",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9265",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10447",
  "video-data-lib": "/video-data-lib/static-1.35555",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4508",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6446",
  "customer-data-properties": "/customer-data-properties/static-1.52223",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18972",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5267",
  "onboarding-tours": "/onboarding-tours/static-1.16948",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8283",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9260",
  "user-context": "/user-context/static-1.5297",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.853",
  "hubspotter-http": "/hubspotter-http/static-1.4781",
  "icons": "/icons/static-2.666",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.552",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.953",
  "quartz-head": "/quartz-head/static-1.943",
  "quartz-test": "/quartz-test/static-1.953",
  "quartz-tracking": "/quartz-tracking/static-1.657",
  "trellis-components": "/trellis-components/static-1.2320",
  "ui-fonts": "/ui-fonts/static-1.923",
  "usage-tracker-container": "/usage-tracker-container/static-1.7526",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9612",
  "data-token-picker": "/data-token-picker/static-1.16730",
  "FileManagerLib": "/FileManagerLib/static-1.39813",
  "property-translator": "/property-translator/static-1.5579",
  "atom": "/atom/static-1.5261",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6188",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5772",
  "react-create-root-preference": "/react-create-root-preference/static-1.46",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1207",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4558",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2301",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3106",
  "foundations-theming-base": "/foundations-theming-base/static-1.3608",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4941",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5950",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.253",
  "chirp-fetch": "/chirp-fetch/static-1.2073",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4662",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4838",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12927",
  "content-media-compositions": "/content-media-compositions/static-2.16934",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4333",
  "magpie-lib": "/magpie-lib/static-1.5679",
  "magpie-types": "/magpie-types/static-1.5139",
  "media-bridge-lib": "/media-bridge-lib/static-1.19247",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3976",
  "superstore": "/superstore/static-1.4944",
  "feedback-loader": "/feedback-loader/static-1.29639",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9438",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8892",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29092",
  "ContentUtils": "/ContentUtils/static-1.68920",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4610",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4799",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1395",
  "copilot-toolkit": "/copilot-toolkit/static-1.11621",
  "avatar-components": "/avatar-components/static-1.2684",
  "navigation-messaging": "/navigation-messaging/static-1.7865",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8361",
  "commerce-products-lib": "/commerce-products-lib/static-1.10262",
  "crm-message-bus": "/crm-message-bus/static-1.43526",
  "growth-data-modal": "/growth-data-modal/static-1.5730",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5063",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5162",
  "calling-global-api": "/calling-global-api/static-1.65153",
  "calling-internal-common": "/calling-internal-common/static-1.31497",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66535",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58829",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3927",
  "crm-links": "/crm-links/static-1.6501",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4268",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13217",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9744",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8282",
  "external-options-client-types": "/external-options-client-types/static-1.4256",
  "formula-editor": "/formula-editor/static-1.14585",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7080",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.364",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4346",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.817",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3822",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49367",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4097",
  "property-value-citations": "/property-value-citations/static-1.2837",
  "pulse": "/pulse/static-1.800",
  "smart-property-lib": "/smart-property-lib/static-1.8070",
  "tiered-pricing": "/tiered-pricing/static-1.1745",
  "topics-actions-lib": "/topics-actions-lib/static-1.337",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11175",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3247",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2473",
  "navigation-components": "/navigation-components/static-1.18538",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1014",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7828",
  "ui-universal-auth": "/ui-universal-auth/static-1.9198",
  "batch-promise": "/batch-promise/static-1.1730",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18090",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10415",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5222",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1133",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6190",
  "FileManagerCore": "/FileManagerCore/static-1.39672",
  "FileManagerImages": "/FileManagerImages/static-1.37324",
  "video-components": "/video-components/static-1.13899",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1314",
  "purchase-motions-api": "/purchase-motions-api/static-1.6191",
  "signup-constants": "/signup-constants/static-1.19344",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8244",
  "usage-tracker-public": "/usage-tracker-public/static-1.7347",
  "reactive-lib": "/reactive-lib/static-1.908",
  "simple-logging-lib": "/simple-logging-lib/static-1.3235",
  "chatspot-core": "/chatspot-core/static-1.22268",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6766",
  "cms-field-types": "/cms-field-types/static-1.5001",
  "content-icons-ui": "/content-icons-ui/static-1.2280",
  "integrations-lib": "/integrations-lib/static-1.16757",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.673",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.961",
  "customer-data-tracking": "/customer-data-tracking/static-1.7070",
  "products-iframe-lib": "/products-iframe-lib/static-1.8380",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10799",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1381",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2282",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.522",
  "calling-error-reporting": "/calling-error-reporting/static-1.31504",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11223",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6726",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1673",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7433",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9826",
  "bark-lib": "/bark-lib/static-1.16677",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6073",
  "react-codemirror": "/react-codemirror/static-1.10821",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.199",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4136",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6985",
  "persist-promise": "/persist-promise/static-1.3887",
  "event-emitter": "/event-emitter/static-1.1135",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.303",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.487",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10500",
  "fsm": "/fsm/static-1.3916",
  "policy-lib": "/policy-lib/static-1.6971",
  "react-tinymce": "/react-tinymce/static-1.55749",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10563",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54875",
  "tinymce-plugins": "/tinymce-plugins/static-1.57989",
  "tinymce-themes": "/tinymce-themes/static-1.56845",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2501",
  "user-context-client": "/user-context-client/static-1.4737",
  "nest": "/nest/static-1.421",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.994",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4717",
  "video-embed": "/video-embed/static-1.36389",
  "social-insights-client-types": "/social-insights-client-types/static-1.22580",
  "flux-actions": "/flux-actions/static-1.353",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14172",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5793",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7964",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10550",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.712",
  "sales-views-client-types": "/sales-views-client-types/static-1.4443",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15332",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7792",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36450",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3715",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16126",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4692",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3227",
  "tinymce-data": "/tinymce-data/static-1.40960",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5398",
  "layout-dnd-components": "/layout-dnd-components/static-1.12799",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11774",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15986",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9181",
  "outpost": "/outpost/static-1.4351",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3197",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.235",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.733",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.802",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.907",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.249",
  "slack-ui-library": "/slack-ui-library/static-1.10583",
  "ContentData": "/ContentData/static-1.68995",
  "layout-data-lib": "/layout-data-lib/static-1.10099",
  "advanced-menus-core": "/advanced-menus-core/static-1.15431",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12325",
  "ExportDialog": "/ExportDialog/static-6.10565",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34573",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15430",
  "simple-menus-lib": "/simple-menus-lib/static-1.16947"
}
};
